import { isDebugMode } from './debug'

export const getCountryCode = ({
  defaultCountry = 'US',
  onStart = () => {},
  onFinish = () => {},
  onSuccess = (country: string) => {},
  onError = (error: any) => {}
} = {}) => {
  onStart()

  const urlParams = new URLSearchParams(window.location.search)
  const rewriteIp = urlParams.get('btly-rewrite-ip')
  const isDebug = isDebugMode('#main')
  let mainUrl = 'https://ipinfo.io/json'

  if (rewriteIp) {
    mainUrl = `https://ipinfo.io/${rewriteIp}/json`
  }

  fetch(mainUrl)
    .then(response => {
      if (!response.ok) {
        throw `${response.status} response status`
      }
      return response.json()
    })
    .then(data => {
      if (isDebug) {
        console.groupCollapsed('IP Info')
        console.table(data)
        console.groupEnd()
      }
      onSuccess(data.country)
    })
    .catch(error => {
      console.error('API IP Info error:', error)
      onError(error)
      onSuccess(defaultCountry)
    })
    .finally(onFinish)
}
